import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Spinner } from "@/components/ui/spinner";
import { doKeycloakLogin } from "@/services/keycloak";

type KeycloakLoginTransitionProps = {
  returnPath: string;
};

export const LoginLoading = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-dvh w-full items-center justify-center text-primary">
      <Spinner className="size-10 motion-reduce:animate-none">
        <title>{t("common.loading")}</title>
      </Spinner>
    </div>
  );
};

export const KeycloakLoginTransition = ({
  returnPath,
}: KeycloakLoginTransitionProps) => {
  const loginStarted = useRef(false);

  useEffect(() => {
    if (loginStarted.current) return;

    loginStarted.current = true;
    void doKeycloakLogin(returnPath);
  }, [returnPath]);

  return <LoginLoading />;
};
